import { FactoryDetail } from '../bus/factory/types';
import $axios from '../utils/axios-instance';

export default class FactoryApi {
  async getFactoryDetail({ id }: { id: number }) {
    return await $axios
      .get<FactoryDetail>(`/v1/factory/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getFactoryCreate(data: FactoryDetail) {
    return await $axios
      .post('/v1/factory/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getFactoryEdit(data: FactoryDetail) {
    return await $axios
      .put(`/v1/factory/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getFactoryDelete(data: FactoryDetail) {
    return await $axios
      .delete(`/v1/factory/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
